<template>
    <div>
        <form ref="form">
            <b-form-group>
                <b-row>
                    <b-col sm="4"> <label for="accountNo"> LDAP Filtre ismi </label> </b-col>
                    <b-col sm="8"> <b-form-input id="accountNo" v-model="name" placeholder="LDAP Filtre ismi" /></b-col>
                </b-row>
               <div style="margin-top: 1rem; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between; overflow-y: scroll; height: 400px;">
                    <div class="filterInputs" v-for="a in attributes" :key="'filter-'+a.ID">
                        <b-form-checkbox class="filterChck" style="" v-model="a.checked">
                            {{a.Name}}
                        </b-form-checkbox>
                        <b-form-input class="filterInput" :placeholder="a.Name" v-model="a.val" :disabled="!a.checked"></b-form-input>
                    </div>
                </div>
                        
            </b-form-group>
        </form>
    </div>
</template>
<style scoped>
.bv-no-focus-ring{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-bottom:1rem
}
.filterInputs{
    display: flex;
    flex-direction: row;
    margin-bottom:1rem;
    width: 400px
}
.filterChck{
    flex: 1; 
    text-align:left
}
.filterInput{
    flex: 1;
}
</style>

<script>
    import i18n from '@/plugins/i18n';

    export default {
        name: "ADFilter",
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function
        },
        mounted: async function(){
            await this.$store.dispatch('ADAttribute_list')
        },
        data: function(){
            return {
                name: this.data ? this.data.name : ""
            }
        },
        computed:{
            attributes(){
                return this.$store.getters.getADAttributes
            }
        },
         watch:{
            save: async function(data){
                if(data){
                    let val = {
                        name: this.name,
                    }
                    
                    switch(this.modalName){
                        case "add":
                            await this.$store.dispatch('addJobs', val)
                            break;  
                        case "edit":
                            val.id = this.data.id
                            await this.$store.dispatch('editJobs', val)
                            break;  
                    }
                    if(this.$store.getters.getStatus.status == "Success"){
                        this.$store.dispatch('ADAttribute_list')
                        this.clearForm()
                    }
                }
                this.saveState(false)
            },
            data: function (val){
                this.name = val.name
            }
        },
     
        methods:{
             clearForm(){
                this.name = ""
                this.modalEvent(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/ADFilter.vue